var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 2.00024V0.500244C15 0.220244 14.78 0.000244141 14.5 0.000244141H13.5C13.22 0.000244141 13 0.220244 13 0.500244V2.00024H7V0.500244C7 0.220244 6.78 0.000244141 6.5 0.000244141H5.5C5.22 0.000244141 5 0.220244 5 0.500244V2.00024H0.5C0.22 2.00024 0 2.22024 0 2.50024V19.5002C0 19.7802 0.22 20.0002 0.5 20.0002H19.5C19.78 20.0002 20 19.7802 20 19.5002V2.50024C20 2.22024 19.78 2.00024 19.5 2.00024H15ZM18 18.0002H2V10.0002H18V18.0002ZM18 8.00024H2V4.00024H5V5.50024C5 5.78024 5.22 6.00024 5.5 6.00024H6.5C6.78 6.00024 7 5.78024 7 5.50024V4.00024H13V5.50024C13 5.78024 13.22 6.00024 13.5 6.00024H14.5C14.78 6.00024 15 5.78024 15 5.50024V4.00024H18V8.00024Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/Calendar.0e9c785838ae042861529bea59b5fbae.svg";
export { ForwardRef as ReactComponent };